import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'chassis-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit, OnChanges, OnDestroy {

    @Input() prefix: string;

    public _urls: any[];
    public _routerSubscription: any;

    constructor(private router: Router) {
    }

    ngOnInit(): void {

        this._urls = [];
        this.generateBreadcrumbTrail(this.router.url);

        this._routerSubscription = this.router.events.subscribe((navigationEnd: NavigationEnd) => {

            if (navigationEnd instanceof NavigationEnd) {
                this._urls = [];
                this.generateBreadcrumbTrail(navigationEnd.urlAfterRedirects ? navigationEnd.urlAfterRedirects : navigationEnd.url);
            }
        });

    }

    ngOnChanges(changes: any): void {

        if (!this._urls) {
            return;
        }

        this._urls.length = 0;
        this.generateBreadcrumbTrail(this.router.url);

    }

    generateBreadcrumbTrail(url: string): void {

        const uri_segments = url.split('/');

        let pointer = 0;
        for (const uri_segment of uri_segments) {
            if (uri_segment !== '') {
                const label = uri_segment.split('?').slice(0, 1).join('');
                this._urls.push({
                    label: label,
                    url: uri_segments.slice(0, pointer + 1).join('/')
                });

            } else if (uri_segment === '' && pointer === 0) {
                this._urls.push({
                    label: this.prefix,
                    url: '/'
                });

            }

            pointer++;
        }
    }

    navigateTo(url: string): void {

        this.router.navigateByUrl(url);

    }

    ngOnDestroy(): void {

        this._routerSubscription.unsubscribe()
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/layouts/components/partials/breadcrumb/breadcrumb.component.ts